export default __webpack_public_path__ + "static/media/Slider-2-alt2.50d1ecc4.jpg";